import {DI} from '../types'
import {ContainerModule, ContainerModuleLoadOptions} from 'inversify'
import {ThirdPartyOAuthComponentFactory} from '@/src/features/auth/core/oauth-types'
import {OAuthComponentMapping} from '@/src/features/auth/core/oauth-mapping'

const initializeModule = ({bind}: ContainerModuleLoadOptions) => {
  bind<ThirdPartyOAuthComponentFactory>(DI.ThirdPartyOAuthComponentFactory).toFactory(
    () =>
      function Factory(provider) {
        const Component = OAuthComponentMapping[provider]

        if (!Component) {
          throw Error(`Маппинг для провайдера ${provider} не найден`)
        }

        return <Component />
      },
  )
}

export const LoginModule = new ContainerModule(initializeModule)
